"use strict";

const ukUA = {
  save: 'Зберегти',
  selectSingle: 'Оберіть дату',
  selectMultiple: 'Оберіть дати',
  selectRange: 'Оберіть період',
  notAccordingToDateFormat: inputFormat => `Формат дати має бути ${inputFormat}`,
  mustBeHigherThan: date => `Має бути пізніше ніж ${date}`,
  mustBeLowerThan: date => `Має бути раніше ніж ${date}`,
  mustBeBetween: (startDate, endDate) => `Має бути між ${startDate} - ${endDate}`,
  dateIsDisabled: 'Цей день не дозволено обирати',
  previous: 'Попередній',
  next: 'Наступний',
  typeInDate: 'Введіть дату',
  pickDateFromCalendar: 'Оберіть дату з календаря',
  close: 'Закрити',
  hour: 'Година',
  minute: 'Хвилина'
};
export default ukUA;
//# sourceMappingURL=ukUA.js.map